import React from 'react'
import PropTypes from 'prop-types'

import { getTresholdValue } from '@util/tresholdUtil'
import { statusColors } from '@generators/tresholdConstants'
import { Status } from './Status'
import { Box } from './Box'
import { TresholdDisplay } from './ThresholdDisplay'

export const CharacteristicStatus = ({ value, type }) => {
  const category = getTresholdValue(type, value)

  return (
    <div
      style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}
    >
      <div>
        <Status
          text={category}
          backgroundColor={`${statusColors[category]}1A`}
          textColor={statusColors[category]}
          style={{ marginRight: 24 }}
        />
      </div>
      <Box width={223.5}>
        <TresholdDisplay value={value} type={type} />
      </Box>
    </div>
  )
}

CharacteristicStatus.propTypes = {
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  type: PropTypes.string.isRequired,
}
